import React from 'react';

import { formatMoney } from '@betterment/core';
import { Icon, ListRow, Text } from '@betterment/samba-react';

import { LegacyTransferTypeEnum, type RecurringTransactionConfig } from './types';
import { configFrequencyCopy } from './utils';

type Props = {
  config: RecurringTransactionConfig;
  isWithdrawal: (sourceLegacySubAccountId: number) => boolean;
};

const isMoneyOutflow = (
  config: RecurringTransactionConfig,
  isWithdrawal: (sourceLegacySubAccountId: number) => boolean
): boolean => {
  const { legacyTransferType, source } = config;
  if (legacyTransferType === LegacyTransferTypeEnum.Withdrawal) {
    return true;
  }
  if (legacyTransferType === LegacyTransferTypeEnum.Deposit) {
    return false;
  }
  if (source?.__typename === 'CashAccount' || source?.__typename === 'ManagedSubAccount') {
    return isWithdrawal(source.legacySubAccountId);
  }
  return false;
};

export const RecurringTransactionsConfig: React.FC<Props> = ({ config, isWithdrawal }) => {
  const isOutflow = isMoneyOutflow(config, isWithdrawal);
  const iconName = isOutflow ? 'ArrowCircleMinus' : 'ArrowCirclePlus';
  const { destinationName, sourceName, amount } = config;
  const transactionDirection = isOutflow ? `to ${destinationName}` : `from ${sourceName}`;

  return (
    <>
      <ListRow.LeadingAsset>
        <Icon name={iconName} size="small" />
      </ListRow.LeadingAsset>
      <ListRow.LeadingContent>
        <Text>{`${formatMoney(amount)} ${transactionDirection}`}</Text>
        <Text variant="text50" color="text.weak">
          {configFrequencyCopy(config)}
        </Text>
      </ListRow.LeadingContent>
    </>
  );
};
